// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"s5-z","trustedRetailerTooltipWrapper":"t5-z"};